/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/8/28
 * Time: 下午3:09
 * 本文件的方法是处理markdown语法有关的操作
 */

import { MARKDOWN_MATCH } from '../markdown'
// import { MARKDOWN_QUILL } from '../markdown/quillMarkdown'
import { Store } from '../../../common'
import _ from 'lodash'

const editorMarkdownType = ['olist', 'ulist', 'tlist']

export function handleMarkdown (quill, str) {
  for (let item of MARKDOWN_MATCH) {
    if (item.regexObj && item.regexObj.test(str)) {
      setTimeout(() => {
        item.handleMarkdown(quill)
      }, 10)
      break
    } else {
      if (item.options && item.options.length > 0) {
        for (let childItem of item.options) {
          if (str.search(childItem.regexObj) !== -1) {
            setTimeout(() => {
              childItem.handleMarkdown(quill)
            }, 10)
            break
          }
        }
      }
    }
  }
}

export function handleEditorMarkdown (self, delta) {
  if (!delta || delta.length !== 3) return
  const markdownType = _getEditorMarkdownType(delta)
  console.log('quill-markdown type匹配结果', markdownType)
  if (!editorMarkdownType.includes(markdownType)) return
  Store.store('sendMessageLock', true)
  const deltaArray = _getDelta(delta)
  self.$emit('send-message', deltaArray[0])
  self.$emit('send-message', deltaArray[1])
  Store.store('sendMessageLock', false)
}

function _getEditorMarkdownType (delta) {
  const attributesObj = _.find(delta, item => item.attributes)
  if (!attributesObj || !attributesObj.attributes) return ''
  if (attributesObj.attributes.list === 'ordered') return 'olist'
  if (attributesObj.attributes.list === 'bullet') return 'ulist'
  if (attributesObj.attributes.list === 'unchecked') return 'tlist'
  return ''
}

function _getDelta (delta) {
  let deltaData = []
  deltaData.push([delta[0], delta[1]])
  deltaData.push([delta[0], delta[2]])
  return deltaData
}



// WEBPACK FOOTER //
// ./src/components/quill/core/markdown.js